import fetch from 'isomorphic-fetch';
import qs from 'query-string';

import { checkStatus, parseJSON, dispatchError } from '../utils/fetch';
import {
  CLEAR_RESERVATION_REQUEST,
  CLEAR_RESERVATION_FAILURE,
  CLEAR_RESERVATION_SUCCESS,
  CLEAR_RESERVATION_TIMEOUT
} from '../constants/ActionTypes';

function clearReservationRequest(sale, resId, pkgId) {
  return {
    type: CLEAR_RESERVATION_REQUEST,
    sale,
    resId,
    pkgId
  };
}

function clearReservationFailure(sale, resId, pkgId) {
  return {
    type: CLEAR_RESERVATION_FAILURE,
    sale,
    resId,
    pkgId
  };
}

function clearReservationSuccess(sale, resId, pkgId) {
  return {
    type: CLEAR_RESERVATION_SUCCESS,
    sale,
    resId,
    pkgId,
    timeout: setTimeout(clearReservationTimeout, 5000)
  };
}

function clearReservationTimeout() {
  return {
    type: CLEAR_RESERVATION_TIMEOUT
  };
}

export default function clearReservation(resId, pkgId) {
  return (dispatch, getState) => {
    const config = getState().config;

    const {
      sale: { sale }
    } = getState();

    dispatch(clearReservationRequest(sale, resId, pkgId));

    return fetch(
      `${config.apiUrl}/sales/${
        sale.id
      }/clearreservation/${resId}?${qs.stringify({
        client: config.client
      })}`,
      {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(() => {
        dispatch(clearReservationSuccess(sale, resId, pkgId));
      })
      .catch((...args) => {
        dispatchError(
          dispatch,
          clearReservationFailure.bind(this, sale, resId, pkgId)
        )(...args);
      });
  };
}
